import axios from 'axios'


const kullaniciDelete = async (id) => {
    let response;
    var config = {
        method: 'delete',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/user/delete/'+id,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            
            response = res;
        })
        .catch((err) => {
            console.log(err);
        });
    return response;
};

export default kullaniciDelete;
